import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "o-brokerMapCard__brokerPortrait" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "o-brokerMapCard__content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  alt: "logo",
  src: "/assets/images/logo.svg",
  class: "o-brokerMapCard__logo"
}, null, -1 /* HOISTED */)
const _hoisted_5 = ["textContent"]
const _hoisted_6 = { class: "a-label o-brokerCard__info" }
const _hoisted_7 = ["textContent"]
const _hoisted_8 = ["textContent"]
const _hoisted_9 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_icon = _resolveComponent("a-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["o-brokerMapCard", { 'o-brokerCard--flexible': $props.flexible }])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["o-brokerMapCard__wrapper", { 'o-brokerMapCard__wrapper--showAsLink': $props.isLink }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.showBroker($props.data.url)))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("img", {
          src: $options.formattedUrl,
          class: "o-brokerMapCard__image",
          alt: "Billede af mægleren"
        }, null, 8 /* PROPS */, _hoisted_2)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("h2", {
          class: "a-heading2 o-brokerMapCard__name",
          textContent: _toDisplayString($props.data.name.replace('danbolig ', ''))
        }, null, 8 /* PROPS */, _hoisted_5),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", {
            textContent: _toDisplayString(`${$props.data.address ? $props.data.address + ' ' : ''}`)
          }, null, 8 /* PROPS */, _hoisted_7),
          _createElementVNode("div", {
            textContent: _toDisplayString(
                            `${$props.data.zipCode ? $props.data.zipCode + ' ' : ''}${$props.data.city}`
                        )
          }, null, 8 /* PROPS */, _hoisted_8)
        ])
      ])
    ], 2 /* CLASS */),
    ($data.showPhoneLink)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          href: `tel:${$props.data.phone}`,
          class: "o-brokerMapCard__phoneLink"
        }, [
          _createVNode(_component_a_icon, { name: "phone" })
        ], 8 /* PROPS */, _hoisted_9))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}